module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//gorilla_6_3.png?v=bfe54049";